import { FormEvent, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { FormGroup, FormGroupField, FormGroupIcon, FormGroupLabel } from '@/shared/components/form/FormElements';
import { AccountButton, AccountButtons, LoginForm } from '../AccountElements';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import { useNavigate, useSearchParams } from 'react-router';
import { useLoginWithEmail } from '@/services/auth';

const LogInForm = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { mutateAsync: loginWithEmail, isPending } = useLoginWithEmail();
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const onLoginSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!isLoading && !isPending && email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                setErrorMessage('Please enter a valid email address');
                return;
            }

            setIsLoading(true);
            try {
                const AUTH_REDIRECT_TO = import.meta.env.VITE_AUTH_REDIRECT_TO;
                // Fail fast + clearly on a misconfigured build (a missing or
                // scheme-less VITE_AUTH_REDIRECT_TO) instead of round-tripping to
                // Firebase only to get the opaque "continue URL must be a valid
                // URL string." The API normalizes too, but this is the local guard.
                if (!AUTH_REDIRECT_TO || !/^https?:\/\//i.test(AUTH_REDIRECT_TO)) {
                    setErrorMessage('Login is misconfigured (redirect URL is missing its https:// scheme). Contact an admin.');
                    return;
                }
                const redirectTo = AUTH_REDIRECT_TO + (searchParams.get('redirectTo') || '/users');

                // callApi resolves { status:'error' } rather than throwing — so check
                // it and only advance to the "check your email" page on success.
                // Otherwise a failed send would strand the user on a dead page.
                const result = await loginWithEmail({ email, redirectTo });
                if (result.status === 'error') {
                    setErrorMessage(result.error?.message ?? 'Failed to send the login email. Please try again.');
                    return;
                }

                navigate(`/email-confirmation?email=${email}`, { state: { email } });
            } catch (error) {
                if (error instanceof Error) {
                    setErrorMessage(error.message);
                } else {
                    setErrorMessage('An unknown error occurred');
                }
            } finally {
                setIsLoading(false);
            }
        }
    };

    return (
        <LoginForm onSubmit={onLoginSubmit}>
            <Alert variant="danger" show={!!errorMessage}>
                {errorMessage}
            </Alert>
            <FormGroup>
                <FormGroupLabel>Email</FormGroupLabel>
                <FormGroupField>
                    <FormGroupIcon>
                        <AccountOutlineIcon />
                    </FormGroupIcon>
                    <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value?.toLowerCase())}
                        name="username"
                        type="email"
                        placeholder="Email"
                        className="input-without-border-radius"
                    />
                </FormGroupField>
            </FormGroup>
            {/* <FormGroup>
                        <FormGroupLabel>Password</FormGroupLabel>
                        <FormGroupField>
                            <PasswordField name="password" placeholder="Password" className="input-without-border-radius" keyIcon />
                            <AccountForgotPassword>
                                <NavLink to="/reset_password">Forgot a password?</NavLink>
                            </AccountForgotPassword>
                        </FormGroupField>
                    </FormGroup> */}
            <AccountButtons>
                {/* {form === 'modal_login' ? ( */}
                <AccountButton type="submit" variant="primary" disabled={isLoading || isPending || !email}>
                    Sign In
                </AccountButton>
                {/* ) : ( */}
                {/* <AccountButton as={NavLink} variant="primary" to="/online_marketing_dashboard">
                                Sign In
                            </AccountButton> */}
                {/* )} */}
                {/* <AccountButton as={NavLink} variant="outline-primary" to="/register">
                            Create Account
                        </AccountButton> */}
            </AccountButtons>
        </LoginForm>
    );
};

export default LogInForm;
